<template>
  <transition name="fade">
    <div v-if="footerContent" class="seo-footer-container">
      <CollapsibleText
        class="seo-footer-content"
        :collapse-button-text="$t('dictionary.readLess')"
        :content="footerContent"
        :expand-button-text="$t('dictionary.readMore')"
        :max-lines="3"
        button-alignment="right"
      />
    </div>
  </transition>
</template>

<script>
import CollapsibleText from '@sephora-asia/core-collapsible-text/CollapsibleText.vue'

export default {
  name: 'SeoFooterContainer',

  components: {
    CollapsibleText
  },

  props: {
    footerContent: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
.seo-footer-container {
  padding-top: 10px;
}

::v-deep .text-content {
  h1,
  h2,
  h3 {
    font-weight: bold;
    margin-bottom: 5px;
  }

  p {
    margin-bottom: 5px;
  }

  h2 {
    font-size: 16px;
  }

  h3 {
    font-size: 14px;
  }
}
</style>
